import { isNullOrUndefined, reduce } from "et3-type-guards";

export const getDateAsObject = (date: Date) => {
  if (isNullOrUndefined(date)) {
    return {
      year: "",
      month: "",
      day: ""
    };
  }
  const dateObject = {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  };
  return dateObject;
};

export const getSpecificDateWithDays = (props: {
  daysAdded: number;
  daysSubtracted: number;
}) => {
  const daysAdded = reduce(() => props.daysAdded, 0);
  const daysSubtracted = reduce(() => props.daysSubtracted, 0);
  const date = new Date();
  date.setDate(date.getDate() - daysSubtracted + daysAdded);
  return date;
};
